module.exports = __webpack_public_path__ + "img/device.89db5589.png";